module.exports = __webpack_public_path__ + "lp/img/recording_light_stop.461106f9.svg";